import React from "react";

import "./index.scss";

const MainButton = ({
  text,
  onClick,
  variant = "primary",
  className,
  isDisabled = false,
}) => {
  return (
    <button
      disabled={isDisabled}
      onClick={onClick}
      className={`main-button  ${isDisabled ? "disabled" : ""} ${variant} ${className} `}
    >
      {text}
    </button>
  );
};

export default MainButton;
